const AppId = '0ae2b562-c4bd-479d-b281-1f34a6f8c2f2';
// const AdminServer = 'http://admin.dev.in-store.hk:84';
// const AdminServer = 'https://admin.uat.intimex.hk';
const AdminServer = 'https://ns-admin.win.eventizer.hk';
module.exports = {
  // instore app id admin的id
  AppId: AppId,
  // api server url 統一配置Api服務器的url
  // ApiServer: 'http://api.dev.in-store.hk:84',
  // ApiServer: 'https://api.uat.intimex.hk',
  ApiServer: 'https://ns-api.win.eventizer.hk',
  // api version for this app 統一配置Api版本號
  ApiVersion: 'V2',
  // api Authorization 身份认证，用于后端识别客户端
  Authorization: 'MGFlMmI1NjItYzRiZC00NzlkLWIyODEtMWYzNGE2ZjhjMmYyOjJkZmJkMzI4LTIyOWUtNDY3Zi1iZmY4LTQwNTI1ZTFlYTE3NA==',
  // admin server url, for login management platform 統一配置admin服務器

  AdminServer: AdminServer,
  // url '/admin' auto open admin tab
  AutoOpenAdmin: true,
  // admin login url 統一配置admin登錄地址
  AdminLoginUrl: AdminServer + '/default/ClientLogin/' + AppId,
  // 前端默认配置
  FrontE: {
    mobileBuilding: false,
    pcBuilding: false,
    cmsSeoList: [],
    productSeoList: ['Home']
  }
};
